import { gql } from '@apollo/client';
export const GET_HOMEPAGE_CAROUSEL = gql`
	query {
		homePageCarousel
	}
`;
